import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Spin } from "antd";
import ErrorBoundary from "components/ErrorBoundary";
import NetworkStatus from "components/NetworkStatus";
import GlobalErrorHandler from "components/GlobalErrorHandler";
import { Header } from "screens/header";
import "./App.css";

// 路由懒加载
const Home = lazy(() =>
  import("screens/home").then((module) => ({ default: module.Home })),
);
const Detail = lazy(() =>
  import("screens/detail").then((module) => ({ default: module.Detail })),
);

// 加载中组件
const PageLoading = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
      width: "100%",
      flexDirection: "column",
      gap: "16px",
    }}
  >
    <Spin size="large" />
    <div style={{ color: "#64748b", fontSize: "14px" }}>加载中...</div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <GlobalErrorHandler />
        <BrowserRouter>
          <NetworkStatus />
          <Header />
          <div className="content">
            <Suspense fallback={<PageLoading />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/detail/:id" element={<Detail />} />
              </Routes>
            </Suspense>
          </div>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
